"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  // FAILED_CONNECTION_NOTIFICATION: '',
  // Do not localize {Retry}; it is a placeholder for "Retry". English translation should be, "Send failed. Retry."
  SEND_FAILED_KEY: "nepoda\u0159ilo se odeslat, {Retry}.",
  // SLOW_CONNECTION_NOTIFICATION: '',
  Chat: 'Chat',
  // 'Download file': '',
  // 'Microphone off': '',
  // 'Microphone on': '',
  'Listening…': 'Poslouchám…',
  Retry: 'opakovat',
  Send: 'Odeslat',
  Sending: 'Odesílání',
  Speak: 'Použít hlas',
  // 'Starting…': '',
  Tax: 'Daň z prod.',
  Total: 'Celkem',
  'Type your message': 'Napište svou zprávu',
  'Upload file': 'Nahrát soubor',
  VAT: 'DPH' // 'X minutes ago':

};
exports.default = _default;